import * as React from 'react';

const CompletedProjectArrowLeft = React.forwardRef<HTMLDivElement | null>((_, ref) => {
  return (
    <div
      className={'swiper-arrow arrow-left'}
      onClick={(event) => {
        event.stopPropagation();
      }}
      ref={ref}
    >
      <svg
        fill={'none'}
        height={24}
        viewBox={'0 0 24 24'}
        width={24}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={'M6 12H18M6 12L11 7M6 12L11 17'}
          strokeLinecap={'round'}
          strokeLinejoin={'round'}
          strokeWidth={2}
          stroke={'#ffffff'}
        />
      </svg>
    </div>
  );
});

export default CompletedProjectArrowLeft;